export default {
  authStatus: "",
  token: localStorage.getItem("token") || "",
  user: null
};
